import { IonCol, IonGrid, IonLoading, IonModal, IonRow } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import TitlePage from "../TitlePage/TitlePage";
import "./Reader.css";

import { pdfjs } from "react-pdf";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import { mapBook } from "../Book/BookUtils";
import PDFViewer from "../Book/Viewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {
  name: string;
  pages: number[];
  title: string;
  onHitLastPage?: () => any;
  url?: string;
}

const Reader: React.FC<Props> = ({
  name,
  title,
  pages,
  onHitLastPage = () => null,
  url,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [bookLoader, setBookLoader] = useState<boolean>(true);
  const techno = useRef(localStorage.getItem("techno") ?? "");
  const isCharOrPrim =
    localStorage.getItem("techno") === "char" ||
    localStorage.getItem("techno") === "prim";

  useEffect(() => {
    mapBook.get(getCurrentTechnoOrDisconnect() + "-techno");
  });

  return (
    <>
      <IonRow className="ion-justify-content-center flex">
        <IonCol size-lg="5" size-sm="5" onClick={() => setModalOpen(true)}>
          <p
            // style={{ padding: "5px 50px 5px 50px" }}
            className="bold hover-underline response-button"
          >
            {name}
          </p>
        </IonCol>
      </IonRow>

      <IonModal
        className="modal-width"
        isOpen={modalOpen}
        trigger="open-modal"
        onWillDismiss={() => {
          setModalOpen(false);
        }}
      >
        <IonGrid className="primary fullWidth overflow-auto">
          <IonRow class="ion-justify-content-center">
            <IonCol size-lg="10" size-sm="10">
              <TitlePage title={title} subTitle="" />
            </IonCol>
          </IonRow>
          <IonRow>
            <div className="fullWidth margin">
              <IonLoading
                message={"Chargement..."}
                cssClass={"spinner"}
                isOpen={bookLoader}
              />
              <div style={{ height: 500 }}>
                <PDFViewer
                  fileURL={getFileUrl(url, techno.current + "-techno")}
                  setBookLoader={(isLoad) => setBookLoader(isLoad)}
                  initialPage={pages[0]}
                  endPage={pages[pages.length - 1]}
                  onHitLastPage={onHitLastPage}
                  label="Première page"
                />
              </div>
            </div>
          </IonRow>
          <IonCol
            onClick={() => window.location.reload()}
            offset="1"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "85%",
            }}
          >
            <p className="bold hover-underline response-button fit-content">
              Accéder au quiz
            </p>
          </IonCol>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: " end",
              paddingRight: 20,
            }}
          >
            <p
              onClick={() => window.location.reload()}
              className="bold hover-underline response-button fit-content"
            >
              Retour au thème
            </p>
          </div>
        </IonGrid>
      </IonModal>
    </>
  );
};

export default Reader;

export const getFileUrl = (url?: string, filePath?: string) => {
  const file = mapBook.get(filePath ?? "");
  if (url !== undefined && url.length > 0) return url;
  if (filePath !== undefined && file !== undefined) return file;
  return "";
};
